<template>
  <component
    :is="componentType"
    class="tw-flex tw-items-center tw-py-3 tw-cursor-pointer"
    v-bind="linkAttributes"
    @click="handleClick"
  >
    <i-user-avatar
      :avatar="person.avatar_url && person.avatar_url['128'] && `${$baseHost}/${person.avatar_url['128']}`"
      :fullname="person.relation_with_fullname"
      :status="person.status"
      size="small"
      class="tw-mr-3"
    />
    <div>
      <div class="tw-flex">
        <div class="tw-flex-col">
          <div class="tw-flex">
            <strong class="tw-text-dark dark:tw-text-dm-dark tw-leading-tight">
              {{ person.relation_with_fullname }}
            </strong>
            <i-badge
              v-if="messagesCount"
              type="primary"
              size="small"
              class="tw-ml-2"
              is-circle
            >
              {{ messagesCount }}
            </i-badge>
          </div>
          <span class="tw-text-gray-dark">
            {{ relationType }}
          </span>
        </div>
      </div>
      <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-leading-tight">
        {{ person.relation_type_name }}
      </div>
    </div>
    <div class="tw-flex-1">
      <i-button
        size="small"
        is-icon
        class="tw-ml-auto tw-rounded-lg"
      >
        <icon-angle-right />
      </i-button>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
    link: {
      type: Function,
      default: (id) => `/foreigners/${id}`,
    },
    redirectOnClick: {
      type: Boolean,
      default: true,
    },
    storePath: {
      type: String,
      required: true,
    },
  },

  computed: {
    state() {
      const stateFragment = this.storePath.split('/').reduce((acc, key) => acc[key], this.$store.state);
      return stateFragment;
    },
    messagesCount() {
      const item = this.state.family.find(({ foreigner_id }) => foreigner_id === this.person.relation_with_id);
      return item ? item.message_count : 0;
    },
    relationType() {
      const relationType = this.$store.getters['v2/shared/enums/get']('family_relations', this.person.relation_type);
      return relationType ? relationType.name : '';
    },
    componentType() {
      return this.redirectOnClick ? 'router-link' : 'div';
    },
    linkAttributes() {
      if(this.redirectOnClick) {
        return {
          to: this.link(this.person.relation_with_id),
        };
      }
      return {};
    },
  },
  methods: {
    handleClick() {
      if (!this.redirectOnClick) {
        this.$emit('family-member-click');
      }
    },
  },
};
</script>
